<template>
  <div class="admin-vacancies-scene">
    <table class="admin-table">
      <thead>
        <tr>
          <th class="column-id">ID</th>

          <th class="column-date">{{ $tr('admin_console.company.candidate.details.vacancy') }}</th>

          <!-- <th class="column-name">{{ $tr('admin_console.company.candidate.details.manager') }}</th> -->

          <th class="column-company">
            {{ $tr('admin_console.company.candidate.details.candidate') }}
          </th>

          <!-- <th class="column-vacancy">{{ $tr('admin_console.company.candidate.details.region') }}</th> -->

          <th class="column-status">
            {{ $tr('admin_console.company.candidate.details.contacts') }}
          </th>

          <!-- <th class="column-stage">{{ $tr('admin_console.company.candidate.details.status') }}</th>

          <th class="column-questions">{{ $tr('admin_console.company.candidate.details.techStatus') }}</th> -->

          <th class="column-questions">
            {{ $tr('admin_console.company.candidate.details.vacancyStatus') }}
          </th>

          <th class="column-questions">
            {{ $tr('admin_console.company.candidate.details.stage') }}
          </th>

          <th class="column-questions">
            {{ $tr('admin_console.company.candidate.details.createdAt') }}
          </th>

          <!-- <th class="column-questions">{{ $tr('admin_console.company.candidate.details.sendInviteDate') }}</th>

          <th class="column-questions">{{ $tr('admin_console.company.candidate.details.changeStatusDate') }}</th> -->

          <!-- <th class="column-questions">{{ $tr('admin_console.company.candidate.details.response') }}</th>

          <th class="column-questions">{{ $tr('admin_console.company.candidate.details.progress') }}</th>

          <th class="column-questions"></th> -->
        </tr>
      </thead>

      <tbody>
        <tr>
          <td>{{ candidate_id }}</td>
          <td>{{ vacancy_name }}</td>
          <td>{{ candidate_name }}</td>
          <td>
            <div>{{ candidate_email }}</div>
            <div>{{ candidate_phone }}</div>
          </td>
          <td>{{ status }}</td>
          <td>{{ stage }}</td>
          <td>{{ created_at }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Moment from 'moment';

import { STORE_PREFIX } from '../../constants.js';
import { mapGetters } from 'vuex';

export default {
  name: 'AdminCandidatesScene',

  props: {
    response_id: null
  },

  computed: {
    ...mapGetters(STORE_PREFIX + 'admin/candidate', ['candidate', 'pagination']),

    candidate_id() {
      if (!this.candidate || !this.candidate.id) {
        return '';
      }

      return this.candidate.id;
    },

    vacancy_name() {
      if (!this.candidate || !this.candidate.vacancy) {
        return '';
      }

      return this.candidate.vacancy.name;
    },

    is_japan_locale() {
      return this.$store.getters['locale/is_japan_locale'];
    },

    candidate_name() {
      if (!this.candidate || !this.candidate.candidate) {
        return '';
      }

      return !this.is_japan_locale
        ? `${this.candidate.candidate.first_name} ${this.candidate.candidate.last_name}`
        : `${this.candidate.candidate.last_name} ${this.candidate.candidate.first_name}`;
    },

    candidate_email() {
      if (!this.candidate || !this.candidate.candidate) {
        return '';
      }

      return this.candidate.candidate.email || '';
    },

    candidate_phone() {
      if (!this.candidate || !this.candidate.candidate) {
        return '';
      }

      return this.candidate.candidate.phone || '';
    },

    status() {
      if (!this.candidate || !this.candidate.status) {
        return '';
      }

      return this.candidate.status.name || '';
    },

    stage() {
      if (!this.candidate || !this.candidate.stage) {
        return '';
      }

      return this.candidate.stage.name || '';
    },

    created_at() {
      if (!this.candidate || !this.candidate.created_at) {
        return '';
      }

      return Moment(this.candidate.created_at, 'YYYY-MM-DD').format('DD-MM-YYYY') || '';
    }
  },

  beforeMount() {
    this.fetch();
  },

  methods: {
    fetch() {
      this.$store.dispatch(STORE_PREFIX + 'admin/candidate/fetch', {
        response_id: this.response_id
      });
    }
  }
};
</script>
